import React from "react";
import { Box, Flex, Button } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
// import provinces from "../../../../assets/JSON/";
function Landing() {
  const navigate = useNavigate();
  const handleClick = () => {
    navigate("/landing/form");
  };
  return (
    <Flex
      justifyContent="center"
      alignItems="center"
      className="landing-container"
    >
      <Button colorScheme="blue" h="50" onClick={handleClick} className="landing-button">
        نوبت دهی ملاقات حضوری 
        <br></br>
        (دفتر کل آ پ ، آ . غ)
      </Button>
    </Flex>
  );
}

export default Landing;
